/**
 * The sub-pages of an Engineering Domain, in nav order. Single source of truth for
 * BOTH the domain page's top tab bar and the sidebar's per-domain submenu, so the
 * two ways of navigating a domain always stay in sync. `to` is the route segment
 * (relative to `/domains/:domainId`).
 */
export const DOMAIN_TABS = [
  { to: 'overview', label: 'Overview' },
  // The action surface — the product's core — sits second, right after the
  // summary (Action over Visibility). Route slug stays `cost-optimization` so
  // existing deep-links / breadcrumbs keep working; only the label changed.
  { to: 'cost-optimization', label: 'Optimizations' },
  // CI/CD shift-left PR reviews — a findings surface alongside Optimizations.
  // Always present (everyone can view); when reviews are off the page itself
  // explains the capability and links to Settings to enable it.
  { to: 'reviews', label: 'Reviews' },
  // NIS2 compliance lens — posture + gaps for the domain. Shown only when the
  // `compliance` feature flag is on for the org (the Sidebar filters it); the
  // page itself handles the "not yet enabled on this domain" state.
  { to: 'compliance', label: 'NIS2 Compliance' },
  { to: 'explorer', label: 'Explorer' },
  // Connected sources live on their own tab (slug stays `integrations` so deep
  // links keep working); domain-wide settings — access + system settings —
  // split out to a dedicated Settings tab.
  { to: 'integrations', label: 'Integrations' },
  { to: 'settings', label: 'Settings' },
] as const;

export type DomainTab = (typeof DOMAIN_TABS)[number];
